/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { CompanyWizardStore } from './company-wizard-store';

export const CompanyWizardStoreContext = createContext<CompanyWizardStore>({} as CompanyWizardStore);
